import React, { useState } from "react";
import HomeTab from "./HomeTab";
import LeaveTab from "./LeaveTab";
import { LeaveSection } from "./LeavePage";
import AddEmployeeForm from "./AddEmployeeForm";
import AllEmployeeDetails from "./EmployeeInfo";
import MyAttendanceTab from "./MyAttendanceTab"; 
import SeparationPage from "./SeparationPage";
import PayrollPage from "./PayrollPage";
import MusterGrid from "./Muster";
import FinalSettlementPage from "./FinalSettlementPage";

type ExtendedLeaveSection = LeaveSection | "balance";
type TabKey = "home" | "muster" | "leave" | "AddEmployeeForm" | "EmployeesInfo" | "MyAttendance" | "Separation" | "FinalSettlementPage" | "PayrollPage";

const tabs: { key: TabKey; label: string }[] = [
  { key: "home", label: "Home" },
  { key: "MyAttendance", label: "Attendance" },
  { key: "muster", label: "Muster"},
  { key: "leave", label: "Leave" },
  { key: "AddEmployeeForm", label: "Add Employee" },
  { key: "EmployeesInfo", label: "Employees Info" },
  { key: "Separation", label: "Separation" },
  { key: "FinalSettlementPage", label: "Final Settlement"},
  { key: "PayrollPage", label: "Payroll"},
];

const Attendance: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("home");
  const [activeLeaveSection, setActiveLeaveSection] =
    useState<ExtendedLeaveSection>("balance");

  return (
    <div className="min-h-screen">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Tab Buttons */}
        <div
          className={`grid mb-4 border-b border-gray-200`}
          style={{
            gridTemplateColumns: `10% repeat(${tabs.length}, 1fr) 10%`,
          }}
        >
          {/* Empty left space */}
          <div></div>

          {/* Tabs */}
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`text-center px-4 py-1 text-sm font-medium rounded-t-lg transition-all ${
                activeTab === tab.key
                  ? "text-blue-600 border-b-2 border-blue-500 bg-white"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`}
            >
              {tab.label}
            </button>
          ))}

          {/* Empty right space */}
          <div></div>
        </div>

        {/* Tab Content */}
        {activeTab === "home" && <HomeTab />}
        {activeTab === "MyAttendance" && <MyAttendanceTab />}
        {activeTab === "muster" && <MusterGrid />}
        {activeTab === "leave" && (
          <LeaveTab
            activeSection={activeLeaveSection}
            onSectionChange={setActiveLeaveSection}
          />
        )}
        {activeTab === "AddEmployeeForm" && <AddEmployeeForm />}
        {activeTab === "EmployeesInfo" && <AllEmployeeDetails />}
        {activeTab === "Separation" && <SeparationPage />}
        {activeTab === "FinalSettlementPage" && <FinalSettlementPage />}
        {activeTab === "PayrollPage" && <PayrollPage />}
      </div>
    </div>
  );
};

export default Attendance;
